import { render, staticRenderFns } from "./EmailView.vue?vue&type=template&id=52ff4915&scoped=true"
import script from "./EmailView.vue?vue&type=script&lang=js"
export * from "./EmailView.vue?vue&type=script&lang=js"
import style0 from "./EmailView.vue?vue&type=style&index=0&id=52ff4915&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ff4915",
  null
  
)

export default component.exports